export default __webpack_public_path__ + "static/media/security-manager-right.7ed3b851.png";